import { render, staticRenderFns } from "./Offerings.vue?vue&type=template&id=0c23b0e5&"
import script from "./Offerings.vue?vue&type=script&lang=js&"
export * from "./Offerings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports